<template>
    <div class="home">
        <Login/>
    </div>
</template>

<script>
    import Login from "@/components/Login.vue";
    import router from "../router/index.js";
    
    export default {
        name: "Connection",
        components: {
            Login,
        },
        data(){
            return{
            }
        },
        created: function() {
            if (this.$store.state.connected) {
                router.push('/');
            } 
        }
    };
</script>

<style scoped>
    .home {
        height: 800px;
    }
</style>
